import Config from '../config';
import styleVariables from '../stylesheets/_variables.scss';

function getBrowserLanguage(defaultLanguage) {
  if (typeof window === 'undefined') {
    return defaultLanguage;
  }

  const { language, browserLanguage, userLanguage } = window.navigator;
  const locale = (language || browserLanguage || userLanguage || 'fr').split('-')[0];

  if (Config.supportedLocales.includes(locale)) {
    return locale;
  }
  return defaultLanguage;
}

const mobileDetect = () => {
  if (typeof navigator !== 'undefined') {
    const { userAgent } = navigator;

    const isAndroid = () => Boolean(userAgent.match(/Android/i));
    const isIos = () => Boolean(userAgent.match(/iPhone|iPad|iPod/i));

    const isMobile = () => window.matchMedia(`all and (max-width: ${styleVariables.mobileMaxWidth})`).matches;
    const isTablet = () => window.matchMedia(`all and (min-width: ${styleVariables.mobileMaxWidth}) and (max-width: ${styleVariables.tabletMaxWidth})`).matches;
    const isTabletLandscape = () => window.matchMedia(`all and (min-width: ${styleVariables.mobileMaxWidth}) and (max-width: ${styleVariables.tabletMaxWidth}) and (orientation: landscape`).matches;
    const isTabletPortrait = () => window.matchMedia(`all and (min-width: ${styleVariables.mobileMaxWidth}) and (max-width: ${styleVariables.tabletMaxWidth}) and (orientation: portrait`).matches;
    const isDesktop = () => !isMobile() && !isTablet();

    return {
      isMobile,
      isTablet,
      isTabletLandscape,
      isTabletPortrait,
      isDesktop,
      isAndroid,
      isIos,
    };
  }

  const isMobile = () => false;
  const isTablet = () => false;
  const isTabletLandscape = () => false;
  const isTabletPortrait = () => false;
  const isDesktop = () => !isMobile() && !isTablet();

  return {
    isMobile,
    isTablet,
    isTabletLandscape,
    isTabletPortrait,
    isDesktop,
  };
};

export {
  getBrowserLanguage,
  mobileDetect,
};
